module.exports = __webpack_public_path__ + "4dc1dbb7e1b732b5b7dbd0923acb28b4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/bunny-beak.png
// module id = 1198
// module chunks = 0